import csv from 'csv-parser'
import { map, pick, snakeCase } from 'lodash'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function extractEmailsFromCsv(text: string): string[] {
  const tokens = text
    .split(/[\n,;]+/)
    .map((s) => s.trim().replace(/^["']|["']$/g, ''))
    .filter((s) => s.length > 0)

  const valid = tokens.filter((t) => EMAIL_REGEX.test(t))

  const seen = new Set<string>()
  return valid.filter((email) => {
    const lower = email.toLowerCase()
    if (seen.has(lower)) return false
    seen.add(lower)
    return true
  })
}

export async function readCsvFile(filePath: string) {
  try {
    const response = await fetch(filePath)
    const text = await response.text()
    return text
  } catch (error) {
    console.error('Error reading CSV file:', error)
    throw error
  }
}

export async function parseCsvData(csvText: string) {
  return new Promise((resolve, reject) => {
    const parsedData: any = []
    const stream = csv()

    stream.on('data', (row) => parsedData.push(row))
    stream.on('end', () => resolve(parsedData))
    stream.on('error', (error) => reject(error))

    stream.write(csvText)
    stream.end()
  })
}

export async function loadDataFromCsv(
  filePath: string,
  customAttributes?: Array<string>,
  isTimeZone = false
) {
  try {
    const csvText = await readCsvFile(filePath)
    const parsedData: any = await parseCsvData(csvText)

    const firstRow = parsedData[0]
    const numColumns = Object.keys(firstRow).length

    return map(parsedData, (item: any) => {
      const itemValue =
        numColumns > 1 && item.id ? item.id : Object.values(item)[0]
      const itemLabel =
        numColumns > 1 && item.name ? item.name : Object.values(item)[0]

      return {
        value: isTimeZone ? itemValue : snakeCase(item.name),
        label: itemLabel,
        ...pick(item, [...(customAttributes || [])]),
      }
    })
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}
